import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { RowArgs } from '@progress/kendo-angular-grid';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DispatchRefTrackQVBus } from '@app/cp/shared/models/DispatchRefTrackQVBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { ApiResponseList } from '@app/cp/shared/models/ApiResponse';
import { DispatchRefTrackSearch } from '@app/cp/shared/models/DispatchRefTrackSearch';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'cp-dispatch-reftrack-details',
    templateUrl: './dispatch-reftrack-details.component.html',
    styleUrls: ['./dispatch-reftrack-details.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DispatchReftrackDetailsComponent extends BaseGridComponent<DispatchRefTrackQVBus, null> implements OnInit, OnDestroy, OnChanges {

    subscriptions: Subscription[] = [];
    searchParam: WidgetSearch;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.subscriptions.push(svc_dashboard.dispatchReviewRefresh$.subscribe(
            refresh => {
                this.loaderState = true;
                this.getData();
            }));
    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();

    loaderState: boolean = true;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    exportFilteredData: any[];

    get isConstructionSelected(): boolean {
        return this.searchParam != null && this.searchParam.srvConstInt == 2;
    }

    initialLoad: boolean = true;
    public selectionKey(context: RowArgs): string {
        return context.dataItem.dispatchId;
    }
    private subs_featureFlagSet: Subscription; //place as class variable
    featureFlagSet = {};
    ngOnInit() {

        this.initialLoad = false;
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe((data: any) => {
        this.featureFlagSet = data;
            this.setup(this.dataFilter);
        });
    }
    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_featureFlagSet); //place in ngOnDestroy
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    getData() {
        this.loaderState = true;
        this.hideError();
        if (this.featureFlagSet["dispatch-reftracking-oncall"]) {
            let search = new DispatchRefTrackSearch(this.searchParam);
            this.subs_data = this.svc_dashboard.getDashboardRefTrackingDetails_v2(search).subscribe((info: ApiResponseList) => {
                if (!info.success) {
                    this.handleNetworkError(info.message);
                }
                else {
                    this.data = info.resultList;
                    this.originalGridData = _.cloneDeep(info.resultList);

                    this.gridData = orderBy(filterBy(this.originalGridData, this.filter), this.sort);

                    this.loaderState = false;
                    if (this.lastIdLoaded) {
                        this.selection = [];
                        this.selection.push(this.lastIdLoaded);
                        this.state.skip = this.lastSkip;
                        this.lastIdLoaded = null;
                    }

                    this.gridData = _.cloneDeep(info.resultList);
                    this.loaderState = false;
                }
            });
        }
        else {
            this.subs_data = this.svc_dashboard.getDashboardRefTrackingDetails(this.searchParam).subscribe((info: BaseMessageInfo) => {
                if (info == null || info.saveError || info.primaryReturn == null) {
                    this.handleNetworkError(null);
                } else {

                    this.data = info.primaryReturn;

                    this.originalGridData = _.cloneDeep(info.primaryReturn);
                    this.gridData = orderBy(filterBy(this.originalGridData, this.filter), this.sort);

                    this.loaderState = false;
                    if (this.lastIdLoaded) {
                        this.selection = [];
                        this.selection.push(this.lastIdLoaded);
                        this.state.skip = this.lastSkip;
                        this.lastIdLoaded = null;
                    }

                    this.gridData = _.cloneDeep(info.primaryReturn);
                    this.loaderState = false;
                }
            },
                error => this.handleNetworkError(error));
        }
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
    showDetailsPopup(id: string, type: number) {

        this.lastIdLoaded = id;
        this.selection = [];
        this.selection.push(this.lastIdLoaded);
        this.lastSkip = this.state.skip;

        this.svc_dashboard.openDQOIPopup(id, type);
    }
    showDispatchRefrigQVPopup(dispatch) {
        this.lastIdLoaded = dispatch;
        this.selection = [];
        this.selection.push(this.lastIdLoaded);
        this.lastSkip = this.state.skip;

        this.svc_dashboard.openDispatchRefrigQVPopup(dispatch);
    }
}
